/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  BuilderMfaSettingsResponse,
  MfaEnrollmentStateResponse,
  ProblemDetails,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Stability Level**: `stable`
 * @summary Returns the current user's MFA enrollment + nudge state, or NotApplicable when no doc exists.
 */
export const mfaEnrollmentStateGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MfaEnrollmentStateResponse>(
    { url: `/apix/v2/MfaEnrollmentState`, method: "GET", signal },
    options,
  );
};

export const getMfaEnrollmentStateGetV2QueryKey = () => {
  return [`/apix/v2/MfaEnrollmentState`] as const;
};

export const getMfaEnrollmentStateGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMfaEnrollmentStateGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>
  > = ({ signal }) => mfaEnrollmentStateGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MfaEnrollmentStateGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>
>;
export type MfaEnrollmentStateGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Returns the current user's MFA enrollment + nudge state, or NotApplicable when no doc exists.
 */

export function useMfaEnrollmentStateGetV2<
  TData = Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMfaEnrollmentStateGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Records an MFA enrollment nudge impression for the current user. Returns the post-update state
so the client can avoid a follow-up GET. Returns NotApplicable when no doc exists for the caller.
 */
export const mfaEnrollmentStateNudgesPostV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MfaEnrollmentStateResponse>(
    { url: `/apix/v2/MfaEnrollmentState/nudges`, method: "POST", signal },
    options,
  );
};

export const getMfaEnrollmentStateNudgesPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateNudgesPostV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mfaEnrollmentStateNudgesPostV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["mfaEnrollmentStateNudgesPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mfaEnrollmentStateNudgesPostV2>>,
    void
  > = () => {
    return mfaEnrollmentStateNudgesPostV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MfaEnrollmentStateNudgesPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof mfaEnrollmentStateNudgesPostV2>>
>;

export type MfaEnrollmentStateNudgesPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Records an MFA enrollment nudge impression for the current user. Returns the post-update state
so the client can avoid a follow-up GET. Returns NotApplicable when no doc exists for the caller.
 */
export const useMfaEnrollmentStateNudgesPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateNudgesPostV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mfaEnrollmentStateNudgesPostV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getMfaEnrollmentStateNudgesPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Builder-level MFA requirements for the current org. Requires Admin view; 404 when
Global.Core.Enums.Builders.BTAdminBuilderPreference.BuilderAccountSecurity is off.
 */
export const mfaEnrollmentStateBuilderSettingsGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BuilderMfaSettingsResponse>(
    {
      url: `/apix/v2/MfaEnrollmentState/builder-settings`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getMfaEnrollmentStateBuilderSettingsGetV2QueryKey = () => {
  return [`/apix/v2/MfaEnrollmentState/builder-settings`] as const;
};

export const getMfaEnrollmentStateBuilderSettingsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMfaEnrollmentStateBuilderSettingsGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>
  > = ({ signal }) =>
    mfaEnrollmentStateBuilderSettingsGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MfaEnrollmentStateBuilderSettingsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>
>;
export type MfaEnrollmentStateBuilderSettingsGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Builder-level MFA requirements for the current org. Requires Admin view; 404 when
Global.Core.Enums.Builders.BTAdminBuilderPreference.BuilderAccountSecurity is off.
 */

export function useMfaEnrollmentStateBuilderSettingsGetV2<
  TData = Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mfaEnrollmentStateBuilderSettingsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMfaEnrollmentStateBuilderSettingsGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary One-way: requires MFA for loginType (BTLoginTypes int; only 1 = BUILDER accepted)
in the current org. Idempotent. Full admin only; 404 when
Global.Core.Enums.Builders.BTAdminBuilderPreference.BuilderAccountSecurity is off.
 */
export const mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2 =
  (
    loginType: number,
    options?: SecondParameter<typeof apixHandler>,
    signal?: AbortSignal,
  ) => {
    return apixHandler<BuilderMfaSettingsResponse>(
      {
        url: `/apix/v2/MfaEnrollmentState/builder-settings/requirements/${loginType}/enable`,
        method: "POST",
        signal,
      },
      options,
    );
  };

export const getMfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2MutationOptions =
  <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2
        >
      >,
      TError,
      { loginType: number },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2
      >
    >,
    TError,
    { loginType: number },
    TContext
  > => {
    const mutationKey = [
      "mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2
        >
      >,
      { loginType: number }
    > = (props) => {
      const { loginType } = props ?? {};

      return mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2(
        loginType,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2
      >
    >
  >;

export type MfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2MutationError =
  ErrorType<ProblemDetails>;

/**
 * @summary One-way: requires MFA for loginType (BTLoginTypes int; only 1 = BUILDER accepted)
in the current org. Idempotent. Full admin only; 404 when
Global.Core.Enums.Builders.BTAdminBuilderPreference.BuilderAccountSecurity is off.
 */
export const useMfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2 =
  <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2
        >
      >,
      TError,
      { loginType: number },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof mfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2
      >
    >,
    TError,
    { loginType: number },
    TContext
  > => {
    const mutationOptions =
      getMfaEnrollmentStateBuilderSettingsRequirementsEnableByLoginTypePostV2MutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };
